/** Compatibility fallback is only for older servers, never for an explicit outage. */
export type AccessSummary = {
  effectiveAccess?: { state: "granted" | "denied" | "unavailable"; source: string };
  subscriptionStatus?: unknown;
  compAccess?: boolean | null;
  accessPolicy?: unknown;
};

export function accessState(user: AccessSummary | undefined) {
  if (user?.effectiveAccess) return user.effectiveAccess.state;
  if ((user?.accessPolicy as { temporaryFree?: boolean } | undefined)?.temporaryFree ||
    user?.compAccess || user?.subscriptionStatus === "active" || user?.subscriptionStatus === "trialing") return "granted";
  if (user?.subscriptionStatus === "unknown") return "unavailable";
  return "denied";
}

export function accessUnavailable(user: AccessSummary | undefined) {
  return accessState(user) === "unavailable";
}